<template>
  <b-card v-if="item" no-body class="communication-item">
    <!-- Header -->
    <div class="communication-header">
      <img v-if="item.cover" class="communication-cover" :src="item.cover" alt="Image" />
      <div v-else class="communication-cover" />
      <div class="communication-targets">
        <b-badge
          v-for="(label, labelIndex) in getTargetLabels(item).slice(0, 4)"
          :key="`label-${labelIndex}`"
          pill
          :class="`badge-glow font-weight-normal text-capitalize ${
            labelIndex ? 'ml-50' : ''
          }`"
          variant="light-primary"
          :style="{ color: `#fff !important` }"
        >
          {{ label }}
        </b-badge>
      </div>
    </div>

    <!-- Body -->
    <div class="card-body communication-body">
      <span class="card-title text-capitalize">
        {{ item.title }}
      </span>

      <div class="card-sub-title mt-1 d-flex align-items-center">
        <div class="w-50">
          <b-avatar variant="light-primary" :text="getInitials(item.publisher)" size="24"/>
          {{ $t('questionnaire.by') }}
          <span class="font-weight-bolder text-capitalize">
            {{ item.publisher }}
          </span>
        </div>
        <div
          class="w-50"
          style="display: flex; justify-content: flex-end; align-items: center; border-left: 1px solid #EBE9F1"
        >
          <span v-if="!item.isDraft">
            {{ getExpiredDate(item) }}
          </span>
          <b-badge
            pill
            :variant="communicationStatusVariant(item)"
            class="ml-50 badge-glow font-weight-normal card-status text-capitalize"
          >
            <feather-icon icon="ClockIcon" size="16" />
            {{ communicationStatus(item) }}
          </b-badge>
        </div>
      </div>

      <div class="card-sub-title mt-1">
        <b-badge
          v-for="(role, roleIndex) in item.roles"
          :key="`role-${role}`"
          pill
          :variant="`light-${role === 'sairaanhoitaja' ? 'info' : 'primary'}`"
          :class="`text-capitalize ${roleIndex && 'ml-1'}`"
        >
          {{ role }}
        </b-badge>
      </div>

      <b-card-text class="mt-1">
        {{ item.summary }}
      </b-card-text>
    </div>

    <template #footer>
      <div class="d-flex justify-content-between">
        <div style="width: 100%; display: flex; flex-direction: row; justify-content: space-between;">
          <b-link
            v-if="(isQuestionnaire && item.isDraft) || !isQuestionnaire"
            @click="$emit('edit-communication')"
          >
            <feather-icon icon="Edit3Icon" size="16" />
            <span class="font-weight-bolder">
              {{ $t('questionnaire.edit') }}
            </span>
          </b-link>
          <b-link
            v-if="(isQuestionnaire && item.isDraft) || !isQuestionnaire"
            @click="$emit('delete-announcement')"
          >
            <feather-icon icon="TrashIcon" size="16" />
            <span class="font-weight-bolder">
              {{ $t('delete') }}
            </span>
            <b-spinner v-if="isDeleting" style="width: 16px; height: 16px; margin-left: 5px;" />
          </b-link>
          <template v-if="isQuestionnaire && !item.isDraft">
            <feather-icon icon="CheckCircleIcon" size="16" />
            <span> : {{ item.answersCount }} </span>
            <feather-icon icon="EyeIcon" size="16" class="ml-1" />
            <span> : {{ item.viewDetail ? item.viewDetail.count : 0 }} </span>
            <feather-icon icon="ArchiveIcon" size="16" class="ml-1" />
            <span> : {{ item.targetSize }} </span>
          </template>
        </div>
        <b-link
          v-if="isQuestionnaire"
          :to="{ name: 'apps-questionnaire-view', params: { id: item.id } }"
          class="font-weight-bolder"
        >
          {{ $t('questionnaire.showDetails') }}
        </b-link>
      </div>
    </template>
  </b-card>
</template>

<script>
import { BAvatar, BCard, BCardText, BBadge, BLink, BSpinner } from 'bootstrap-vue'
import { getInitials, handleTimezoneDiff, getTargetLabels } from '@hw-core/utils'
import { COMMUNICATION_TYPES } from '@/shared/constants/communications'
import {
  communicationStatus,
  communicationStatusVariant,
} from '@/shared/services/communicationService'

export default {
  components: {
    BAvatar,
    BCard,
    BCardText,
    BBadge,
    BLink,
    BSpinner,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    isDeleting: {
      type: Boolean,
    },
  },
  data() {
    return {
      COMMUNICATION_TYPES,
    }
  },
  computed: {
    itemExist() {
      return Object.keys(this.item).length > 0
    },
    isQuestionnaire() {
      return this.itemExist && this.item.type === COMMUNICATION_TYPES.QUESTIONNAIRE
    },
    modalType() {
      return this.item.type === COMMUNICATION_TYPES.QUESTIONNAIRE
        ? COMMUNICATION_TYPES.QUESTIONNAIRE
        : COMMUNICATION_TYPES.ANNOUNCEMENT
    },
  },
  methods: {
    getInitials,
    getTargetLabels,
    communicationStatus,
    communicationStatusVariant,
    getExpiredDate(item) {
      if (!item.expirationDate) return ''
      return handleTimezoneDiff(item.expirationDate.toDate())
    },
  },
}
</script>

<style lang="scss" scoped>
@import './styles/communication-item.scss';
</style>
